import {IGetState, TBoardId, TCardId} from '../../../../../../../../types/types';
import {Dispatch, ThunkAction} from '../../../../../../../../types/actions';
import { cardOpen } from '../../../../../../base/effects/cardOpen';

export const onLinkClick = (
    cardId: TCardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(cardOpen(cardId));
    };
    return action;
};
